import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

import img4 from '../../assets/images/background/bg-ft4.png';
import img2 from '../../assets/images/background/bg-ft2.png';
import img5 from '../../assets/images/background/bg-ft5.png';
import img7 from '../../assets/images/background/bg-ft7.png';

Project.propTypes = {
    data: PropTypes.array,
};

function MarqueeRow({ items, reverse }) {
    const loopItems = [...items, ...items];

    return (
        <div className={`collection-marquee ${reverse ? 'is-reverse' : ''}`}>
            <div className="collection-marquee__track">
                {loopItems.map((item, index) => (
                    <div
                        className="collection-marquee__card"
                        key={`${item.id}-${index}`}
                    >
                        <img src={item.img} alt={`Block Pirate ${item.id}`} />
                    </div>
                ))}
            </div>
        </div>
    );
}

MarqueeRow.propTypes = {
    items: PropTypes.array.isRequired,
    reverse: PropTypes.bool,
};

function Project(props) {
    const { data = [] } = props;
    const rowSize = Math.ceil(data.length / 3);
    const firstRow = data.slice(0, rowSize);
    const secondRow = data.slice(rowSize, rowSize * 2);
    const thirdRow = data.slice(rowSize * 2);

    return (
        <section className="tf-section tf-project collection-stream">
            <div className="container-fluid">
                <div className="collection-feature-art" aria-hidden="true">
                    <img src={img2} alt="" className="bg2" />
                    <img src={img4} alt="" className="bg4" />
                    <img src={img5} alt="" className="bg5" />
                    <img src={img7} alt="" className="bg7" />
                </div>

                <MarqueeRow items={firstRow} />
                <MarqueeRow items={secondRow.length ? secondRow : firstRow} reverse />
                <MarqueeRow items={thirdRow.length ? thirdRow : firstRow} />
            </div>
        </section>
    );
}

export default Project;
